export const UTILITIES_MARKET_BASE_PATH = '/utilities/market';
